import React from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { useTranslate } from "context/translateContext"

import CombinedAccountSelect from "./components/CombinedAccountSelect/CombinedAccountSelect"

function getData() {
  const accountsData = useSelector(state => state.accountsList)
  const user = useSelector(state => state.user)

  const upsell = { amazon: { status: false }, ebay: { status: false } }
  const accounts = []

  if (user.isAmazonTokenLinked) {
    accounts.push({
      platform: "amazon",
      account_id: user.id,
      username: user.name,
    })
  } else {
    upsell.amazon = { status: true, userId: user.id }
  }

  if (accountsData?.ebay?.length > 0) {
    accounts.push(...accountsData.ebay)
  } else {
    upsell.ebay = { status: true, userId: user.id }
  }

  return { accounts, upsell }
}

const AccountSelect = props => {
  const location = useLocation()
  const { t: translate } = useTranslate()
  const data = getData()
  return (
    <>
      <div className="m-b-5 w500">{translate("Choose account")}</div>
      <CombinedAccountSelect
        accounts={data.accounts}
        upsell={data.upsell}
        location={location}
        {...props}
      />
    </>
  )
}

export default AccountSelect
